import React from 'react';
import '../../styles/App.css';
import 'ldrs/trio'
import { trio } from 'ldrs'

const Loading = () => {

    trio.register()

    return (
        <div className='container container-page container-loading'>
            <l-trio
                size="40"
                speed="1.3"
                color="white" 
            ></l-trio>
        </div>
    )
}

export default Loading